import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "../../components/Icon/Icon";
import Information from "../../icons/information.svg";
import { useTranslations } from "../../providers/useTranslations";
import styles from "./MessageSku.module.scss";
export const MessageSku = ({ isMiniCart = false, productLimit, displayStatus }) => {
    console.warn("MessageSku component is deprecated / use MessageBox instead.");
    const { __ } = useTranslations();
    return (_jsxs("div", { className: `${isMiniCart ? styles.compact : styles.regular} ${displayStatus ? styles.show : ""}`, "data-testid": "cartQuantity", children: [_jsx(Icon, { width: "30px", height: "30px", component: Information }), _jsxs("p", { children: [__("libs.ui.notification.limit.sku"), " (", productLimit, ")"] })] }));
};
//# sourceMappingURL=MessageSku.js.map